import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-population-chart',
  templateUrl: './population-chart.component.html',
  styleUrls: ['./population-chart.component.scss'],
})
export class PopulationChartComponent implements OnInit {
  @Input() male = false;
  @Input() color = '#FFCD03';
  @Input() percent = 0;

  percents = [];

  ngOnInit(): void {
    this.calculate();
  }

  calculate() {
    const full = Math.floor(this.percent / 10);
    const remain = this.percent % 10;
    this.percents = [];

    for (let i = 0; i < 10; i++) {
      if (i < full) {
        this.percents.push('100%');
      } else if (i === full) {
        this.percents.push(remain + '0%');
      } else {
        this.percents.push('0%');
      }
    }
  }
}
